module.exports = __webpack_public_path__ + "static/media/theta.48e2b2a2.svg";